import React, { useEffect } from "react";
import { render } from "react-dom";
import { ScrollingStats } from "components";

export const useScrollStats = () => {
    useEffect(() => {
        /* Create list of all counter blocks */
        const counterBlocks = Array.from(document.querySelectorAll('.scrolling-stats-wrapper:not(.counterRendered)'));

        if (counterBlocks?.length) {
            const duration = counterBlocks[0].getAttribute('data-duration');
            
            /* Extract data and render JSX.Element */
            counterBlocks.forEach((block, i) => {
                block.classList.add('counterRendered')
                const key = 'app-scoll-count-container-' + i;
                const counters = Array.from(block.querySelectorAll('.counter'));

                /* Data */
                const data = counters.map(((c, i) => ({
                    symbolName: c.classList[1],
                    dataCount: parseInt(c.getAttribute('data-count')),
                    value: c.querySelector('.counter-value').innerHTML,
                    symbol: c.querySelector('.counter-symbol').innerHTML,
                    label: c.getAttribute('label')
                })))

                return render(
                    <ScrollingStats
                        duration={duration}
                        key={'app-scroll-state-wrapper-' + i}
                        counters={data}
                        id={key} />
                    , block)
            });
        }
        
    }, []);
} 